import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
/**
 * Deleting the account stays in the mobile app, so the user gets the
 * cancellation offers and the app's checks for an active App Store or Play
 * subscription. On web, Delete Account shows the QR code that opens the app's
 * account settings instead of starting the delete flow.
 */
export const DeleteModal = {
    show: (_props) => {
        UnavailableOnWebModal.show('emma://settings/account-details', 'Delete account');
    },
    hide: () => {
        UnavailableOnWebModal.hide();
    },
};
export default DeleteModal;
